(async () => {

    const { Core } = await importModule('Core');

    customElements.define('product-options-radio', class extends Core {
        elements = {
            options: '*[data-option-value]',
            selected: '[data-option-value]:checked',
        }

        render() {
            this._handleOptionClicks();
        }

        _handleOptionClicks() {
            this.$options?.forEach(option => {
                option.parentElement.addEventListener('click', () => {
                    if (this.$selected.value !== option.value) {
                        // This is a hack to make the radio buttons checked
                        window.setTimeout(() => {
                            option.checked = true;
                            this.$selected = option;
                        }, 100)
                    }
                });
            });
        }
    });

})();
